import { render, staticRenderFns } from "./YoneticiDuzenle.vue?vue&type=template&id=4d407fd4&scoped=true&"
import script from "./YoneticiDuzenle.vue?vue&type=script&lang=js&"
export * from "./YoneticiDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiDuzenle.vue?vue&type=style&index=0&id=4d407fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d407fd4",
  null
  
)

export default component.exports